
import { useParams } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import API_BASE_URL from "../../../constants/api";

const BlogDetailsArea = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState<any>(null);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}blogs/${id}`)
      .then((res) => setBlog(res.data))
      .catch((err) => console.error("Error loading blog", err));
  }, [id]);

  if (!blog) {
    return <p className="text-center py-5">Loading blog details...</p>;
  }

  return (
    <section className="blog-details-area section-py-120">
      <div className="container">
        <div className="row">
          <div className="col-xl-9 col-lg-8">
            <div className="blog__details-wrapper">
              <div className="blog__details-thumb">
                <img src={blog.blog_image} alt="img" />
              </div>

              <div className="blog__details-content">
                <div className="blog__post-meta">
                  <ul className="list-wrap">
                    <li>
                      <i className="flaticon-calendar"></i>
                      {new Date(blog.date).toLocaleDateString("en-US", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })}
                    </li>
                    <li>
                      <i className="flaticon-user-1"></i> by {blog.author}
                    </li>
                    <li>
                      <i className="flaticon-clock"></i> {blog.read_time}
                    </li>
                    <li>
                      <i className="far fa-comment-alt"></i>{" "}
                      {blog.comments_count} Comments
                    </li>
                  </ul>
                </div>

                <h3 className="title">{blog.title}</h3>
                <p>{blog.content}</p>

                {blog.quote && (
                  <blockquote>
                    <p>{blog.quote}</p>
                  </blockquote>
                )}

                {blog.features && blog.features.length > 0 && (
                  <>
                    <h4 className="inner-title">
                      What Will I Learn From This Course?
                    </h4>
                    <ul className="about__info-list list-wrap">
                      {blog.features.map((point: string, i: number) => (
                        <li key={i} className="about__info-list-item">
                          <i className="flaticon-angle-right"></i>
                          <p className="content">{point}</p>
                        </li>
                      ))}
                    </ul>
                  </>
                )}

                {blog.extra && <p>{blog.extra}</p>}

                <div className="blog__details-bottom">
                  <div className="row align-items-center">
                    <div className="col-xl-6 col-md-7">
                      <div className="tg-post-tag">
                        <h5 className="tag-title">Tags :</h5>
                        <ul className="list-wrap p-0 mb-0">
                          <li>
                            <span>{blog.tag}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-xl-6 col-md-5">
                      <div className="tg-post-social justify-content-start justify-content-md-end">
                        <h5 className="social-title">Share :</h5>
                        <ul className="list-wrap p-0 mb-0">
                          <li>
                            <a href="#">
                              <i className="fab fa-facebook-f"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="fab fa-twitter"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="fab fa-linkedin-in"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="fab fa-pinterest-p"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Uncomment if needed */}
            {/* <BlogAuthor />
            <div className="blog-post-comment">
              <BlogPostComment />
              <BlogForm />
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetailsArea;
